import React from 'react';
import { Button } from '../ui/button';
import { cn } from 'lib/utils';

interface ConfigurationButtonProps extends React.ComponentPropsWithoutRef<typeof Button> {
  icon?: React.ReactNode;
  children: React.ReactNode;
}

const ConfigurationButton = React.forwardRef<HTMLButtonElement, ConfigurationButtonProps>(
  ({ icon, children, className, ...props }, ref) => {
    return (
      <Button
        ref={ref}
        className={cn(
          'text-sm 2xl:text-base h-9 2xl:h-11 w-full shrink-0 gap-2 rounded-full px-4 py-3 font-medium leading-[1.3] shadow-none sm:w-auto',
          className
        )}
        {...props}
      >
        {icon}
        {children}
      </Button>
    );
  }
);

ConfigurationButton.displayName = 'ConfigurationButton';

export default ConfigurationButton;
